import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheck, ShieldCheck, Eye, Award, Users, Lock } from 'lucide-react';
import { CtaButton } from './CtaButton';
const pillars = [{
  icon: Award,
  title: 'Trayectoria comprobada',
  desc: 'Brenda Hormaechea, creadora UGC de Argentina con cuenta verificada y +1.500 alumnas y marcas felices.'
}, {
  icon: ShieldCheck,
  title: 'Seguridad garantizada',
  desc: 'Pago 100% seguro, garantía de 7 días y soporte real de una persona, no un bot.'
}, {
  icon: Eye,
  title: 'Transparencia total',
  desc: 'Sabés exactamente qué recibís, cuánto vale y cómo accedés. Sin letra chica.'
}];
export function TrustSection() {
  return <section className="px-6 py-20 flex flex-col items-center text-center max-w-7xl mx-auto relative" data-id="element-343">
      {/* Eyebrow */}
      <div className="inline-flex items-center gap-2 bg-brand-navy text-brand-cream font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] px-5 py-2 rounded-full mb-6 shadow-sm" data-id="element-344">
        <BadgeCheck size={15} strokeWidth={2.5} className="text-[#D98BAF]" data-id="element-345" />
        Confianza & tranquilidad garantizada
      </div>

      <h2 className="font-serif font-bold text-3xl md:text-5xl text-brand-navy mb-4 leading-tight max-w-4xl" data-id="element-346">
        La comunidad de creadoras UGC y colaboraciones con marcas{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-brand-pinkDark" data-id="element-347">
          más importante del país
        </span>
      </h2>
      <p className="text-brand-navy/70 font-medium text-base md:text-xl max-w-2xl leading-relaxed mb-14" data-id="element-348">
        Un programa creado por{' '}
        <strong className="font-bold" data-id="element-349">Brenda Hormaechea</strong>, de Argentina.
        Detrás de cada video y cada collab paga hay una comunidad real que ya
        confió. 💜
      </p>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16 max-w-5xl" data-id="element-350">
        {/* Instagram proof */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.6
      }} className="relative flex justify-center" data-id="element-351">
          <div className="absolute -inset-4 bg-gradient-to-tr from-brand-lavender/40 via-white to-[#D98BAF]/20 rounded-[3rem] blur-md" data-id="element-352" />
          <div className="relative z-10 rounded-[2rem] overflow-hidden border border-white shadow-[0_25px_60px_-25px_rgba(31,31,46,0.45)] bg-white max-w-[330px]" data-id="element-353">
            <img src="https://cdn.magicpatterns.com/uploads/dsZSeAw3LE7ggLE48TJE51/insta_bren.jpg" alt="Perfil verificado de Instagram de Brenda Hormaechea con 30.9 mil seguidores" className="w-full h-auto block" data-id="element-354" />
          </div>
          {/* Verified badge */}
          <div className="absolute -top-3 -right-1 md:right-4 z-20 flex items-center gap-1.5 bg-[#1d9bf0] text-white font-black text-xs md:text-sm px-4 py-2 rounded-full shadow-lg" data-id="element-355">
            <BadgeCheck size={16} strokeWidth={2.5} data-id="element-356" />
            Cuenta verificada
          </div>
        </motion.div>

        {/* Scale highlight */}
        <div className="flex flex-col gap-6 text-left" data-id="element-357">
          <div className="rounded-3xl p-[2px] bg-gradient-to-r from-[#D98BAF] via-brand-lavenderDark to-[#D98BAF] shadow-[0_18px_45px_-22px_rgba(217,139,175,0.6)]" data-id="element-358">
            <div className="bg-brand-navy rounded-[1.4rem] p-7 md:p-8 relative overflow-hidden" data-id="element-359">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[#D98BAF]/20 blur-[60px] rounded-full pointer-events-none" data-id="element-360" />
              <div className="relative flex items-center gap-3 mb-2" data-id="element-361">
                <Users size={22} className="text-[#D98BAF]" strokeWidth={2.5} data-id="element-362" />
                <span className="text-brand-cream/70 font-semibold text-sm uppercase tracking-widest" data-id="element-363">
                  Somos una comunidad de
                </span>
              </div>
              <p className="relative text-white font-serif font-black text-5xl md:text-6xl tracking-tight mb-1 drop-shadow-[0_0_18px_rgba(217,139,175,0.3)]" data-id="element-364">
                +30.900
              </p>
              <p className="relative text-brand-cream/80 font-medium text-base md:text-lg mb-6" data-id="element-365">
                creadoras de contenido UGC de todo Argentina 🇦🇷
              </p>

              <div className="relative border-t border-white/10 pt-5 flex items-start gap-3" data-id="element-366">
                <div className="w-11 h-11 shrink-0 rounded-xl bg-gradient-to-b from-[#D98BAF] to-brand-pinkDark flex items-center justify-center shadow-[0_0_18px_rgba(217,139,175,0.4)]" data-id="element-367">
                  <Lock size={20} strokeWidth={2.5} className="text-white" data-id="element-368" />
                </div>
                <p className="text-white/90 font-medium text-sm md:text-base leading-relaxed" data-id="element-369">
                  Y solo{' '}
                  <strong className="text-[#D98BAF] font-black text-lg" data-id="element-370">
                    535
                  </strong>{' '}
                  tienen el privilegio de interactuar a diario en el{' '}
                  <strong className="font-bold" data-id="element-371">
                    grupo privado de WhatsApp
                  </strong>{' '}
                  al que accedés realizando tu compra{' '}
                  <strong className="text-[#D98BAF] font-bold" data-id="element-372">hoy</strong>.
                </p>
              </div>
            </div>
          </div>

          <p className="text-brand-navy/60 font-medium text-sm md:text-base leading-relaxed px-1" data-id="element-373">
            Tu lugar en ese grupo es limitado y se libera únicamente con el
            acceso de hoy. Cuando se completa, se cierra.
          </p>
        </div>
      </div>

      {/* Trust pillars */}
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mb-12" data-id="element-374">
        {pillars.map(({
        icon: Icon,
        title,
        desc
      }, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-white border border-black/5 rounded-3xl p-7 flex flex-col items-center text-center shadow-[0_12px_35px_-20px_rgba(31,31,46,0.4)]" data-id="element-375">
            <div className="w-14 h-14 rounded-2xl bg-gradient-to-b from-[#D98BAF] to-brand-pinkDark flex items-center justify-center mb-4 shadow-[0_0_20px_rgba(217,139,175,0.35)]" data-id="element-376">
              <Icon size={26} strokeWidth={2.2} className="text-white" data-id="element-377" />
            </div>
            <h3 className="font-serif font-bold text-brand-navy text-lg md:text-xl mb-2" data-id="element-378">
              {title}
            </h3>
            <p className="text-brand-navy/60 text-sm md:text-base leading-relaxed" data-id="element-379">
              {desc}
            </p>
          </motion.div>)}
      </div>

      <div className="w-full max-w-md md:scale-110 md:my-2" data-id="element-380">
        <CtaButton variant="gold" data-id="element-381">¡QUIERO MI LUGAR EN LA COMUNIDAD!</CtaButton>
      </div>
    </section>;
}